// src/resources/properties/components/PropertyVisibilityActions.tsx
import { Box, IconButton, Tooltip } from "@mui/material";
import { Visibility, Block, CheckCircle } from "@mui/icons-material";
import { useState } from "react";
import { useRecordContext, useNotify } from "react-admin";
import { apiUrl } from "../../../httpClient";
import { handleApiError } from "../../../utils/errorHandler";
import { ADMIN_BASE } from "../../../config";

export const PropertyVisibilityActions = () => {
  const record = useRecordContext();
  const notify = useNotify();
  const [loading, setLoading] = useState(false);

  if (!record) return null;

  const handleVisibilityToggle = async (
    action: "delete" | "close" | "restore",
  ) => {
    setLoading(true);
    try {
      const visibilityData = {
        deleted: action === "delete",
        closed: action === "close",
      };

      if (action === "restore") {
        visibilityData.deleted = false;
        visibilityData.closed = false;
      }

      const response = await fetch(
        apiUrl(`${ADMIN_BASE}/properties/${record.id}/visibility`),
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("tn_admin_access")}`,
          },
          body: JSON.stringify(visibilityData),
        },
      );

      if (!response.ok) {
        throw new Error("Failed to update property visibility");
      }

      notify(
        `Property ${action === "restore" ? "restored" : action + "d"} successfully`,
        { type: "success" },
      );
      // Refresh the list
      window.location.reload();
    } catch (error) {
      const appError = handleApiError(error);
      notify(appError.message, { type: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ display: "flex", gap: 0.5 }}>
      {record.deleted ? (
        <Tooltip title="Restore Property">
          <IconButton
            size="small"
            onClick={() => handleVisibilityToggle("restore")}
            disabled={loading}
            color="success"
          >
            <CheckCircle fontSize="small" />
          </IconButton>
        </Tooltip>
      ) : (
        <>
          <Tooltip title={record.closed ? "Open Property" : "Close Property"}>
            <IconButton
              size="small"
              onClick={() => handleVisibilityToggle("close")}
              disabled={loading}
              color={record.closed ? "success" : "warning"}
            >
              <Visibility fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete Property">
            <IconButton
              size="small"
              onClick={() => handleVisibilityToggle("delete")}
              disabled={loading}
              color="error"
            >
              <Block fontSize="small" />
            </IconButton>
          </Tooltip>
        </>
      )}
    </Box>
  );
};
